app.component('eatlifeCheckMain', {
    templateUrl: 'app/eatlife/eatlife_check_main.html',
    controller: function ($location, $timeout, selfcheckService) {
        var $ctrl = this;
        $ctrl.onSwipeLeft = function() {
            if( $ctrl.selectedIndex < $ctrl.qnomax-1 ) {
                $ctrl.selectedIndex++;
            }
        };
        $ctrl.onSwipeRight = function() {
            if( $ctrl.selectedIndex > 0 ) {
                $ctrl.selectedIndex--;
            }
        }
        // ラジオボタン選択
        $ctrl.radioPushed = function(qItem, index) {
            if( qItem.qid == '00' ) {
                $timeout(function(){
                    if( $ctrl.answerHistory[index].answer != '16' ) {
                        $ctrl.qnomax = $ctrl.answerHistory.length;
                        $ctrl.determinateValue = parseInt( (($ctrl.selectedIndex+1)/$ctrl.qnomax)*100 );
                    }
                    else {
                        $ctrl.qnomax = 22;
                        $ctrl.determinateValue = parseInt( (($ctrl.selectedIndex+1)/$ctrl.qnomax)*100 );
                    }
                }, 0);
            }
            else {
                $ctrl.onSwipeLeft();
            }
        }
        // タブ選択が選択されたタイミングでする処理
        $ctrl.onTabSelected = function() {
            $ctrl.determinateValue = parseInt( (($ctrl.selectedIndex+1)/$ctrl.qnomax)*100 );
        }
        //「チェック結果を見る」クリック
        $ctrl.goResult = function () {
            //飲酒習慣なしの場合は、それ以降の問いは99で初期化する
            if( $ctrl.answerHistory[21].answer == "16" ) {
                for(var i=22; i<$ctrl.answerHistory.length; i++) {
                    $ctrl.answerHistory[i].answer = '99';
                }
            }
            //評価点算出（"99"は除外）
            var gradeScore = getGradeScore($ctrl.answerHistory, "99");
            $location.path("/eatlife_check_result/"+gradeScore);
        };
        //初期化処理
        function init() {
            $ctrl.qnomax = 22;
            $ctrl.selectedIndex = 0;
            $ctrl.determinateValue = parseInt(($ctrl.selectedIndex + 1) / ($ctrl.qnomax + 1)) * 100.0;
            //食生活チェックのカレント問番号
            //$ctrl.questionNo = 0;
            //食生活チェックの問題の取得
            $ctrl.questionTypes = selfcheckService.questionTypes;
            //回答状況を記憶する領域(次ページへ結果渡すための共通領域)初期化
            $ctrl.answerHistory = new Array($ctrl.questionTypes.length);
            for (var i = 0; i < $ctrl.questionTypes.length; i++) {
                $ctrl.answerHistory[i] = {
                    "qid": $ctrl.questionTypes[i].qid,
                    "answer": "99",
                    "text": $ctrl.questionTypes[i].text,
                    "text2": $ctrl.questionTypes[i].text2,
                    "comment": $ctrl.questionTypes[i].comment,
                    "challenge": "0"
                }
            }
        };
        //食生活チェックから評価点を算出
        function getGradeScore(answerHistory, exclusionValue) {
            var score = 0;
            //除外値は評価点から除外
            for (var i = 0; i < answerHistory.length; i++) {
                if (parseInt(answerHistory[i].answer) != exclusionValue) {
                    score += parseInt(answerHistory[i].answer);
                }
            }
            return score;
        };
        $ctrl.$onInit = function () {
            //初期化
            init();
        };
    }
});
